import React from "react";
import PropTypes from "prop-types";
import { ReactComponent as ContainerIcon } from "images/profile/Container.svg";

function EmptyState({ label = "No items", className = "" }) {
  return (
    <div className={`w-full flex flex-col items-center justify-center my-auto ${className}`}>
      <ContainerIcon />
      <div className="font-medium text-[16px] text-[#1D1B22] text-center">{label}</div>
    </div>
  );
}

EmptyState.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
};

export default EmptyState;

